import { getKeyPositionsFromKeyboard, Keyboard, KeyPositions } from './helpers'

const keyboard: Keyboard = [
  ['`', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';'],
  ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
]

export const KEY_POSITIONS: KeyPositions = getKeyPositionsFromKeyboard(keyboard)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants.ts